import { useTranslation } from 'react-i18next';
import navbarProductOptions from '../constants/navbar/navbar-options';
import useGetCountry from '../helpers/useGetCountry';
import CountryEnum from '../constants/country-enum';
import { productsNotAvailableInMexico } from '../constants/products/product-enum';

const useNavbarProducts = () => {
  const { t } = useTranslation();
  const country = useGetCountry();
  const products = navbarProductOptions(t);

  const filtered = country === CountryEnum.MEXICO
    ? products.filter(
      (option) => !productsNotAvailableInMexico.includes(
        option.title.toLowerCase(),
      ),
    )
    : products;

  return filtered;
};

export default useNavbarProducts;
